import request from '@/http'
// let url = process.env.VUE_APP_TECHNOLOGYSHARE // 知识分享项目API
export const apiTechnologyShare = {
  // getBannerList: () => request.get(url + '/cmsBanner/getBannerList'), // 列表banner图
  // searchIndexList: (params) => request.get(url + '/index/vodList', params),
  GetCategoryList: () => request.get('/tech/share/category/list'), // 获取分类
  GetShareList: (params) => request.get('/tech/share/list', params) // 获取列表数据
}
